import { Facebook } from "lucide-react";
import { SITE } from "@/lib/seoData";

/**
 * Premium luxury social-link cluster for OzyLoans.
 * Matte black tile · white icon · subtle red border · red glow + scale on hover.
 * Use anywhere Facebook (and future socials) should appear.
 *
 * Props:
 *   size: "sm" (32px) | "md" (40px, default) | "lg" (48px)
 *   className: extra wrapper classes
 */
const SIZES = {
  sm: "w-8 h-8",
  md: "w-10 h-10",
  lg: "w-12 h-12",
};

const ICON_SIZE = {
  sm: "w-3.5 h-3.5",
  md: "w-4 h-4",
  lg: "w-5 h-5",
};

export default function SocialLinks({ size = "md", className = "" }) {
  const tile =
    "group relative inline-flex items-center justify-center rounded-xl " +
    "bg-[#0a0a0a] border border-[#E50914]/30 text-white " +
    "transition-all duration-200 ease-out " +
    "hover:border-[#E50914] hover:bg-[#140709] hover:scale-110 " +
    "hover:shadow-[0_0_18px_rgba(229,9,20,0.55),0_0_4px_rgba(229,9,20,0.4)] " +
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E50914] focus-visible:ring-offset-2 focus-visible:ring-offset-[#050505] " +
    `${SIZES[size]}`;

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="social-links">
      {SITE.social?.facebook && (
        <a
          href={SITE.social.facebook}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit OzyLoans on Facebook"
          data-testid="social-facebook"
          className={tile}
        >
          <Facebook className={`${ICON_SIZE[size]} text-white group-hover:text-white`} strokeWidth={2.25} />
        </a>
      )}
    </div>
  );
}
